import * as React from "react";
import { attributeDimensionToInt } from "../../lib/embed";
import { SanitizedEmbed } from "./SanitizedEmbed.component";
import type { EmbedLegacyProps } from "@ihr-radioedit/inferno-core";

export const GenericStaticLegacy = (props: EmbedLegacyProps) => {
  const { width = "0", height = "0" } = props.attributes || {};
  const itemClass = ["embed-static"];
  const styles: React.CSSProperties = {};
  styles.width = width?.toString().includes("%") ? width : `${attributeDimensionToInt(width)}px`;
  styles.height = height?.toString().includes("%") ? height : `${attributeDimensionToInt(height)}px`;
  return <SanitizedEmbed html={props.html} classList={itemClass} styles={styles} />;
};

export default GenericStaticLegacy;
